export const CURRENCY_FORMAT = (currencyCode?: string) => {
  if (!currencyCode) {
    currencyCode = "USD";
  }
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currencyCode,
  });
};
